import { ComponentType, SVGProps } from "react";

import icon from "./images/icon.webp";
import logo from "./images/logo.webp";
import aboutUs from "./images/about-us.webp";
import contactUs from "./images/contact-us.webp";
import authPlaceholder from "./images/auth-placeholder.webp";
import homePlaceholder from "./images/home-placeholder.webp";
import parentalControls from "./images/parental-controls.webp";
import academicSolotions from "./images/academic-solutions.webp";
import corporateTraining from "./images/corporate-training.webp";
import registerIndividualPlaceholder from "./images/register-individual-placeholder.webp";
import registerMobilePlaceholderLeft from "./images/register-mobile-placeholder-left.webp";
import registerMobilePlaceholderRight from "./images/register-mobile-placeholder-right.webp";
import registerDesktopPlaceholderLeft from "./images/register-desktop-placeholder-left.webp";
import registerOrganizationPlaceholder from "./images/register-organization-placeholder.webp";
import registerDesktopPlaceholderRight from "./images/register-desktop-placeholder-right.webp";

import FacebookSvg from "./resources/facebook.svg";
import InstagramSvg from "./resources/instagram.svg";
import LinkedinSvg from "./resources/linkedin.svg";
import LoaderSvg from "./resources/loader.svg";
import WebsiteSvg from "./resources/website.svg";
import XSvg from "./resources/x.svg";
import YoutubeSvg from "./resources/youtube.svg";

export {
	aboutUs,
	academicSolotions,
	authPlaceholder,
	contactUs,
	corporateTraining,
	homePlaceholder,
	icon,
	logo,
	parentalControls,
	registerDesktopPlaceholderLeft,
	registerDesktopPlaceholderRight,
	registerIndividualPlaceholder,
	registerMobilePlaceholderLeft,
	registerMobilePlaceholderRight,
	registerOrganizationPlaceholder,
};

export const Facebook: ComponentType<SVGProps<SVGSVGElement>> = FacebookSvg;
export const Instagram: ComponentType<SVGProps<SVGSVGElement>> = InstagramSvg;
export const Linkedin: ComponentType<SVGProps<SVGSVGElement>> = LinkedinSvg;
export const Loader: ComponentType<SVGProps<SVGSVGElement>> = LoaderSvg;
export const Website: ComponentType<SVGProps<SVGSVGElement>> = WebsiteSvg;
export const X: ComponentType<SVGProps<SVGSVGElement>> = XSvg;
export const Youtube: ComponentType<SVGProps<SVGSVGElement>> = YoutubeSvg;
